import { replaceRoute } from '../../lib/router.js';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { setLicenseKey } from 'survey-core';
import ChangeInsightsEditForm from '../../components/change-insights/ChangeInsightsEditForm.jsx';
import { validateFeedbackFormDates } from '../../components/change-insights/SelectSurveyModal/utils.js';
import ChangeInsightsCustomizeDashboardHeader from '../../components/headers/PageHeaders/Project/ChangeInsightsCustomizeDashboardHeader.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import { getOrgSlug } from '../../lib/utils.js';
import {
  selectCurrentOrganizationId,
  selectUser as selectCurrentUser,
} from '../../modules/auth.js';
import {
  retrieveInitiative,
  selectInitiative,
} from '../../modules/initiatives.js';
import { selectUser } from '../../modules/users.js';

import {
  applyChangeInsight,
  createChangeInsight,
  retrieveChangeInsightDetails,
  selectChangeInsightSettings,
  updateChangeInsight,
  updateChangeInsightDetails,
} from '../../modules/changeInsights.js';
import { retrieveOrganization } from '../../modules/organizations.js';
import { retrieveProject, selectProject } from '../../modules/projects.js';
import { selectTemplates } from '../../modules/templates.js';
import {
  CUSTOM_DEFAULT_BRAND_COLOR,
  CUSTOM_DEFAULT_FONT,
  formatedTemplate,
} from './utils/index.jsx';

const mapStateToProps = (
  state,
  { projectId, initiativeId, initiativeType, userId }
) =>
  createSelector(
    selectInitiative(initiativeId, initiativeType),
    (initiative, organization) => ({
      initiative,
      organization,
      initiativeId,
      initiativeType,
      changeInsights: selectTemplates(state),
      organizationId: selectCurrentOrganizationId(state),
      project: selectProject(projectId),
      userId,
      currentUser: selectCurrentUser(state),
      user: selectUser(userId)(state),
      surveyjsKey: state.config.surveyjsKey,
      changeInsightSettings: selectChangeInsightSettings(
        initiative ? initiative.surveyId : null
      )(state),
    })
  )(state);

const mapDispatchToProps = (dispatch, { initiativeId, initiativeType }) =>
  bindActionCreators(
    {
      retrieveInitiative: () =>
        retrieveInitiative(initiativeType, initiativeId),
      retrieveOrganization,
      retrieveChangeInsightDetails,
      updateChangeInsightDetails,
      retrieveProject,
      createChangeInsight,
      updateChangeInsight,
      applyChangeInsight,
    },
    dispatch
  );

const ChangeInsightEditContainer = (props) => {
  const {
    edit,
    organization,
    initiativeType,
    initiativeId,
    organizationId,
    surveyjsKey,
    initiative,
    changeInsightSettings,
    retrieveInitiative,
    retrieveOrganization,
    retrieveChangeInsightDetails,
    updateChangeInsightDetails,
    applyChangeInsight,
  } = props;

  const [errorsFields, setErrorsFields] = useState(null);
  const [loading, setLoading] = useState(false);
  const [changeInsightId, setChangeInsightId] = useState(null);
  const [customTemplate, setCustomTemplate] = useState(null);
  const [creator, setCreator] = useState(null);
  const [selectedDate, setSelectedDate] = useState({
    startDate: null,
    endDate: null,
  });

  const navigateToChangeInsightDetails = () => {
    replaceRoute('change-insights/studio/show', {
      initiativeType,
      initiativeId,
    });
  };

  setLicenseKey(surveyjsKey);

  const onSubmit = (values) => {
    const surveyTemplate = creator.JSON;
    setLoading(true);
    if (surveyTemplate.pages && surveyTemplate?.title) {
      setErrorsFields(null);
      let payload = {};
      if (edit) {
        payload = {
          title: surveyTemplate.title,
          description: surveyTemplate.description,
          surveyJson: JSON.stringify(surveyTemplate),
          startDate: moment(values.startDate).format('DD/MM/YYYY'),
          endDate: moment(values.endDate).format('DD/MM/YYYY'),
        };
      } else {
        payload = {
          title: surveyTemplate.title,
          description: surveyTemplate.description,
          startDate: moment(values.startDate).format('DD/MM/YYYY'),
          endDate: moment(values.endDate).format('DD/MM/YYYY'),
          surveyJson: JSON.stringify(surveyTemplate),
        };
      }

      const actionPromise = edit
        ? updateChangeInsightDetails(changeInsightId, payload)
        : applyChangeInsight(initiative.id, initiative.type, payload);

      actionPromise
        .then(() => {
          navigateToChangeInsightDetails();
        })
        .catch((e) => {
          setErrorsFields({ field: '', message: e.message });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      if (!surveyTemplate.title) {
        setErrorsFields({ field: 'content', message: 'Title is required.' });
      }
      if (!surveyTemplate.pages) {
        setErrorsFields({ field: 'content', message: 'Please fill template.' });
      }
      setLoading(false);
    }
  };

  const onPreview = (surveyTemplate) => {
    if (surveyTemplate?.pages && surveyTemplate?.title) {
      localStorage.setItem(
        'draftTemplate',
        JSON.stringify({
          surveyJson: surveyTemplate,
          settings: {
            brandColor: CUSTOM_DEFAULT_BRAND_COLOR,
            fontName: CUSTOM_DEFAULT_FONT,
          },
        })
      );
      window.open(
        `/${getOrgSlug()}/organization/custom-settings/change-insights/preview/edit/-1`,
        '_blank'
      );
    } else {
      if (!surveyTemplate.title) {
        setErrorsFields({ field: 'content', message: 'Title is required.' });
      }
      if (!surveyTemplate.pages) {
        setErrorsFields({ field: 'content', message: 'Please fill template.' });
      }
    }
  };

  useEffect(() => {
    if (initiative?.surveyId) {
      setChangeInsightId(initiative.surveyId);
    }
  }, [initiative]);

  useEffect(() => {
    retrieveOrganization(organizationId);
    retrieveInitiative(initiativeType, initiativeId);
  }, []);

  useEffect(() => {
    if (changeInsightId) {
      retrieveChangeInsightDetails(changeInsightId);
    }
  }, [changeInsightId]);

  useEffect(() => {
    if (changeInsightSettings?.surveyJson) {
      setCustomTemplate(formatedTemplate(changeInsightSettings));
    }
    if (
      changeInsightSettings &&
      changeInsightSettings.startDate &&
      changeInsightSettings.endDate
    ) {
      setSelectedDate({
        startDate: moment(changeInsightSettings.startDate),
        endDate: moment(changeInsightSettings.endDate),
      });
    }
  }, [changeInsightSettings]);

  return (
    <React.Fragment>
      {initiative ? (
        <ChangeInsightsCustomizeDashboardHeader
          page={`${edit ? 'Edit' : 'Add'} Feedback Template`}
          project={initiative.project}
        />
      ) : null}

      <SubHeader flexJustify>
        <div className="flex w-100" style={{ justifyContent: 'space-between' }}>
          <h2 className="m-r-10 m-l-16">
            {edit ? 'Edit' : 'Add'} Feedback Template
          </h2>
        </div>
      </SubHeader>

      <Grid>
        <Row>
          <Col sm={12} style={{ background: '#ffffff', padding: '0' }}>
            <Form
              initialValues={selectedDate}
              component={ChangeInsightsEditForm}
              onSubmit={onSubmit}
              handlePreview={onPreview}
              validate={validateFeedbackFormDates}
              onCancel={navigateToChangeInsightDetails}
              loading={loading}
              errorsFields={errorsFields}
              organization={organization}
              data={customTemplate}
              creator={creator}
              setCreator={setCreator}
            />
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeInsightEditContainer);
